'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
const CategoryAlgoliaSEO = t0 => {
  const $ = _c(14);
  const {
    categoryData
  } = t0;
  if (!categoryData) {
    return null;
  }
  const {
    pageHtmlTitle: t1,
    pageMetaDescription: t2,
    pageName: t3
  } = categoryData;
  const pageHtmlTitle = t1 === undefined ? "" : t1;
  const pageMetaDescription = t2 === undefined ? "" : t2;
  const pageName = t3 === undefined ? "" : t3;
  let t4;
  if ($[0] !== pageHtmlTitle) {
    t4 = <title>{pageHtmlTitle}</title>;
    $[0] = pageHtmlTitle;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== pageMetaDescription) {
    t5 = <meta name="description" content={pageMetaDescription} />;
    $[2] = pageMetaDescription;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <meta property="og:type" content="category" />;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== pageName) {
    t7 = <meta property="og:title" content={pageName} />;
    $[5] = pageName;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== pageMetaDescription) {
    t8 = <meta property="og:description" content={pageMetaDescription} />;
    $[7] = pageMetaDescription;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t4 || $[10] !== t5 || $[11] !== t7 || $[12] !== t8) {
    t9 = <Helmet>{t4}{t5}{t6}{t7}{t8}</Helmet>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  return t9;
};
CategoryAlgoliaSEO.propTypes = {
  categoryData: PropTypes.shape({
    pageHtmlTitle: PropTypes.string,
    pageMetaDescription: PropTypes.string,
    pageName: PropTypes.string
  })
};
export default CategoryAlgoliaSEO;